import { Routes } from '@angular/router';
import { IsAuthenticated } from './modules/auth/is-authenticated.guard';
import { IsNotAuthenticated } from './modules/auth/is-not-authenticated.guard';
import { StoreObjectGuard } from './guards/store-object.guard.factory';
import { ExamStore } from '@stores/exam.store';
import { RoleAccessGuard } from './guards/role-access';
import { StationStore } from '@stores/station.store';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./pages/authenticated.container').then((c) => c.AuthenticatedContainer),
        canActivate: [IsAuthenticated],
        children: [
            {
                path: '',
                canMatch: [RoleAccessGuard(['osce_organizer', 'osce_admin', 'ADMIN'])],
                loadChildren: () => import('./features/home/home.routes')
                    .then(m => m.HOME_ROUTES)
            },
            {
                path: '',
                canMatch: [RoleAccessGuard(['osce_examiner', 'STUDENT'])],
                loadChildren: () => import('@features/my-osce/my-osce.routes')
                    .then(m => m.MY_OSCE_ROUTES)
            },
            {
                path: 'exam',
                loadChildren: () => import('./features/exam-editing/exam-editing.routes')
                    .then(m => m.EXAM_EDITING_ROUTES)
            },
            {
                path: 'examinate',
                loadChildren: () => import('./features/examinate/examinate.routes')
                    .then(m => m.EXAMINATE_ROUTES)
            },
            {
                path: 'locations',
                loadChildren: () => import('./features/locations/locations.routes')
                    .then(m => m.LOCATIONS_ROUTES)
            },
            {
                path: 'exam/:examId/station',
                canActivate: [StoreObjectGuard('enter', ExamStore, 'examId')],
                canDeactivate: [StoreObjectGuard('leave', ExamStore, 'examId')],
                loadChildren: () => import('./features/station-editing/station-editing.routes')
                    .then(m => m.STATION_EDITING_ROUTES)
            },
            {
                path: 'exam/:examId/station/:stationId/slot',
                canActivate: [
                    StoreObjectGuard('enter', ExamStore, 'examId'),
                    StoreObjectGuard('enter', StationStore, 'stationId'),
                ],
                canDeactivate: [
                    StoreObjectGuard('leave', ExamStore, 'examId'),
                    StoreObjectGuard('leave', StationStore, 'stationId')
                ],
                loadChildren: () => import('./features/slot-editing/slot-editing.routes')
                    .then((e) => e.SLOT_EDITING_ROUTES),
            },
        ]
    },
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.routes').then((routes) => routes.AUTH_ROUTES),
        canActivate: [IsNotAuthenticated],
    },
    {
        path: '**',
        redirectTo: '/'
    }
];
